
//import InputMask from 'react-input-mask';
import PropTypes from "prop-types";
import InputMask from "react-input-mask";

const AddressInfo = ({
  values,
  errors,
  State,
  City,
  setFieldValue,
  handleChange,
}) => (
  <>
    <div>
      <label htmlFor="country">
        Country
        <span className="required-inputs" aria-label="required">
          *
        </span>
      </label>
      <select
        id="country"
        name="country"
        onChange={handleChange}
        value={values.country}
        disabled // Disable because we only show the USA
      >
        <option value="US">United States</option>
      </select>
      {errors.country && <p className="error">{errors.country}</p>}
    </div>

    <div>
      <label htmlFor="state">
        State
        <span className="required-inputs" aria-label="required">
          *
        </span>
      </label>
      <select
        id="state"
        name="state"
        onChange={(e) => {
          setFieldValue("state", e.target.value);
          setFieldValue("city", ""); // Reset city when state changes
        }}
        value={values.state}
      >
        <option value="">Select a state</option>
        {State.getStatesOfCountry(values.country).map((state) => (
          <option key={state.isoCode} value={state.isoCode}>
            {state.name}
          </option>
        ))}
      </select>
      {errors.state && <p className="error">{errors.state}</p>}
    </div>

    <div>
      <label htmlFor="city">
        City
        <span className="required-inputs" aria-label="required">
          *
        </span>
      </label>
      <select id="city" name="city" onChange={handleChange} value={values.city}>
        <option value="">Select a city</option>
        {City.getCitiesOfState(values.country, values.state).map((city) => (
          <option key={city.name} value={city.name}>
            {city.name}
          </option>
        ))}
      </select>
      {errors.city && <p className="error">{errors.city}</p>}
    </div>

    <div>
      <label htmlFor="address">
        Address
        <span className="required-inputs" aria-label="required">
          *
        </span>
      </label>
      <input
        id="address"
        name="address"
        type="text"
        onChange={handleChange}
        value={values.address}
      />
      {errors.address && <p className="error">{errors.address}</p>}
    </div>
    <div className="form-controls">
      <label htmlFor="zipCode">Zip Code:</label>
      <InputMask
        mask="99999" // Mask for 5-digit zip code
        value={values.zipCode}
        onChange={handleChange}
        name="zipCode"
        className={errors.zipCode ? "input-error" : ""}
      >
        {(inputProps) => (
          <input type="text" {...inputProps} placeholder="12345" />
        )}
      </InputMask>
      {errors.zipCode && <span className="error">{errors.zipCode}</span>}
    </div>
  </>
);

AddressInfo.propTypes = {
  values: PropTypes.shape({
    country: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
  }).isRequired,
  errors: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    address: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  touched: PropTypes.shape({
    city: PropTypes.bool,
    state: PropTypes.bool,
    country: PropTypes.bool,
    address: PropTypes.bool,
    zipCode: PropTypes.bool,
  }),
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default AddressInfo;
